import { useMutation } from '@tanstack/react-query';
import { spawn } from '../../utils/translations';
import { RepositoryClient } from '../httpClients/RepositoryClient';
import { SyncGitInstallationRequest } from '../httpClients/RepositoryClient/api.schema';
import { MUTATION_KEYS } from './consts';

export const useSyncGitInstallationMutation = () => {
  const spawnToasts = spawn('toasts.installations.sync-installation');

  return useMutation({
    mutationKey: [MUTATION_KEYS.SYNC_GIT_INSTALLATION],
    mutationFn: async ({ installationId }: SyncGitInstallationRequest) => {
      return await RepositoryClient.syncGitInstallation(installationId);
    },
    onSuccess: () => {
      console.info(spawnToasts('success'));
    },
    onError: (err: any) => {
      console.error(spawnToasts('error'), err);
    },
  });
};
